export default class ServerResponse {
    error = "";
    message = "";
    param1 = "";
    timestamp = "";
    status = 0;
    param2 = "";

    constructor(obj){
        Object.assign(this, obj)
    }

}